import DomainList from "./DomainList";

export default DomainList;
